import {UpdateTimeRegistrationGranularityInput} from './__generated__/UpdateTimeRegistrationGranularityMutation.graphql';
import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';

const mutation = graphql`
	mutation UpdateTimeRegistrationGranularityMutation($input: UpdateTimeRegistrationGranularityInput!) {
		updateTimeRegistrationGranularity(input: $input) {
			timeRegistrationSettings {
				granularity
				allowDoneTasks
				allowProjects
				allowInternalTime
				allowBillableSplit
				allowRoles
				requireTaskAssignment
				requireNote
			}
		}
	}
`;

function getOptimisticResponse(input) {
	return {
		updateTimeRegistrationGranularity: {
			timeRegistrationSettings: {
				id: input.id,
				granularity: input.granularity,
				allowDoneTasks: undefined,
				allowProjects: undefined,
				allowInternalTime: undefined,
				allowBillableSplit: undefined,
				allowRoles: undefined,
				requireTaskAssignment: undefined,
				requireNote: undefined,
			},
		},
	};
}

function commit(
	environment: Environment,
	input: UpdateTimeRegistrationGranularityInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Time Registration Settings', 'Increment Updated', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
